export default {"src":"/_next/static/image/public/images/flags/flag_676.764df6cee324de3438b70190fed26947.svg","height":16,"width":24};